<template>
  <div class="container">
    <div class="detail-content">
      <div class="detail-content-header">
        <p class="fs-20">{{ detailInfo.title }}</p>
        <p class="color-999 mt-20">发布时间：{{ detailInfo.fbstartDate }} &nbsp;&nbsp; 点击量: {{ detailInfo.views }}</p>
      </div>
      <div class="detail-content-body not-reset" v-html="detailInfo.content" />
    </div>
    <!-- 翻页 -->
    <div class="detail-footer flex-between">
      <div class="pre-page">
        <span v-if="detailInfo.prev" @click="viewInfo(detailInfo.prev.id)">上一篇：{{ detailInfo.prev?.title }}</span>
      </div>
      <div class="next-page">
        <span v-if="detailInfo.next" @click="viewInfo(detailInfo.next.id)">下一篇：{{ detailInfo.next?.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import noticeApi from "@/api/newnotice"
import { parseTime } from "@/filters";
export default {
  name: "InfoDetail",
  components: {},
  props: {
  },
  data() {
    return {
      detailInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.id = this.$route.query.id;
    this.getDetail();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 获取详情
    getDetail() {
      noticeApi.detail(this.id).then(res => {
        console.log("详情", res)
        if (res.code === 0) {
          const data = res.data || {}
          data.fbstartDate = parseTime(data.fbstartDate, "{y}-{m}-{d}")
          this.detailInfo = data
          this.$store.commit("permission/SET_DETAIL_TITLE", data.title)
          this.updateView()
        }
      })
    },
    // 查看上下篇
    viewInfo(id) {
      this.$router.replace({
        name: "infoDetail",
        query: {
          id
        }
      })
    },
    // 更新查看
    updateView() {
      noticeApi.updateView(this.id)
    }
  }
};
</script>

<style scoped lang="scss">
  .detail-content{
    background-color: #fff;
    padding: 0 20px;
    border: 1px solid #ddd;
    margin-top: 20px;
    .detail-content-header{
      min-height: 136px;
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .detail-footer{
    height: 50px;
  }
  .pre-page, .next-page{
    width: 48%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    &:hover{
      color: $--color-primary;
    }
  }
  .next-page{
    text-align: right;
  }
</style>
